export default "__VITE_ASSET__8ed24044__"